import { imageBackground } from './presenterHelper';

const LandingpagePresenter = (function () {
  function nullArticle() {
    return {
      id: 0,
      layout: '',
      imageBackground: {},
      imageBackgroundTeaserSrc: '',
      imageBackgroundSrc: '',
      articleForms: [],
      landingpage: {
        headline1: '',
        claim1: '',
        hint1: '',
        questionVideos: [
          {
            id: '',
            src: '',
            preview: ''
          }
        ],
        answerVideo: {
          id: '',
          src: '',
          preview: ''
        },
        answerContent: '',
        headline2: '',
        claim2: '',
        imageForm: '',
        vCheck: '',
        flyingWidgetText: '',
        flyingWidgetButtonText: '',
        phoneNumber: ''
      },
      widgetIds: []
    };
  }

  const LANDINGPAGE_LAYOUTS = [
    'application',
    'headline_landingpage'
  ];

  function getArticle(data) {
    return {
      id: data.id,
      layout: data.selected_layout,
      imageBackground: imageBackground(data.image_focus_hintergrund_mini),
      imageBackgroundTeaserSrc: data.image_focus_hintergrund_teaser[0],
      imageBackgroundSrc: data.image_focus_hintergrund_background[0],
      articleForms: data.content_article_forms,
      landingpage: {
        headline1: data.landingpage_headline_1,
        claim1: data['landingpage.claim_1'],
        hint1: data['landingpage.hint_1'],
        questionVideos: data.landingpage_question_videos,
        answerVideo: data.landingpage_answer_video,
        answerContent: data['landingpage.answer_content'],
        headline2: data['landingpage.headline_2'],
        claim2: data['landingpage.claim_2'],
        imageForm: data.image_teaser_teaser,
        vCheck: data['landingpage.v_check'],
        flyingWidgetText: data['landingpage.flying_widget_text'],
        flyingWidgetButtonText: data['landingpage.flying_widget_button_text'],
        phoneNumber: data['landingpage.phone_number']
      },
      widgetIds: data.widget_ids
    };
  }

  return {
    nullArticle,
    getArticle,
    LANDINGPAGE_LAYOUTS
  };
})();

export default LandingpagePresenter;



// WEBPACK FOOTER //
// ./landingpagePresenter.js